module.exports = __webpack_public_path__ + "img/2fa8fd1b9c97e38aa6f7b1e7bf75847c.3ddc2935.png";